import { render, staticRenderFns } from "./ventasVendedor.vue?vue&type=template&id=5e9edc85&"
import script from "./ventasVendedor.vue?vue&type=script&lang=js&"
export * from "./ventasVendedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports